.root {
  display: flex;
  flex-shrink: 0;
  min-height: 24px;

  & + & {
    margin-top: 1rem;
  }

  @media (--md-down) {
    flex-direction: column-reverse;
  }
}

.content {
  position: relative;
  width: 100%;
  min-height: 42px;

  @media (--md-up) {
    margin-left: 1.5rem;
  }

  &:first-child {
    margin-left: 0;
  }
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 1rem;
  font-size: var(--font-size-body-2);
  font-weight: var(--font-weight-regular);

  @media (--md-down) {
    display: none;
  }

  & > * + * {
    margin-left: 0.5rem;
  }
}

.lineThrough {
  text-decoration: line-through;
  opacity: 0.8;
}
